const DELEGATE_VIEW_SESSION_KEY = ['viewing', 'As', 'Auth', 'Account', 'Id'].join('');

/** Per-tab cache of the last server-confirmed languages (see useLanguages). */
export const LANGUAGE_CACHE_SESSION_KEY = 'lastKnownLanguages';

export const ORG_SCOPED_SESSION_KEYS = [
  DELEGATE_VIEW_SESSION_KEY,
  'currentSelectedPatient',
  'recentPatients',
  LANGUAGE_CACHE_SESSION_KEY,
];

/**
 * Clear org-scoped client state when switching organizations: the delegate
 * "viewing as" selection and org-scoped sessionStorage keys. Shared by the
 * ClinicSwitcher and clinic-select org-switch flows (useClinicSwitch).
 *
 * Template defaults are intentionally NOT cleared here — they are persisted
 * server-side on the auth-scoped user profile, so the correct set loads
 * automatically for the target org.
 */
export const clearOrgScopedUiState = (setViewingAsAuthAccountId: (authAccountId: string | null) => void) => {
  setViewingAsAuthAccountId(null);
  for (const key of ORG_SCOPED_SESSION_KEYS) {
    sessionStorage.removeItem(key);
  }
};
